import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=ca270226&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=ca270226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca270226",
  null
  
)

export default component.exports